import React from 'react';

type Props = {
  fill?: string;
};

const CardPaymentIcon = ({ fill = 'var(--PRIMARY)' }: Props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 8H24C25.1046 8 26 8.89543 26 10V12H6V10C6 8.89543 6.89543 8 8 8ZM6 14V22C6 23.1046 6.89543 24 8 24H24C25.1046 24 26 23.1046 26 22V14H6ZM4 10C4 7.79086 5.79086 6 8 6H24C26.2091 6 28 7.79086 28 10V22C28 24.2091 26.2091 26 24 26H8C5.79086 26 4 24.2091 4 22V10Z"
      fill={fill}
    />
    <path
      d="M13.285 15.2929C13.1025 15.4804 13 15.7348 13 16C13 16.2652 13.1025 16.5196 13.285 16.7071C13.4674 16.8946 13.7149 17 13.973 17H16.5676C16.8256 17 17.0731 16.8946 17.2556 16.7071C17.438 16.5196 17.5405 16.2652 17.5405 16C17.5405 15.7348 17.438 15.4804 17.2556 15.2929C17.0731 15.1054 16.8256 15 16.5676 15H13.973C13.7149 15 13.4674 15.1054 13.285 15.2929Z"
      fill={fill}
    />
    <path
      d="M19.8255 15.2929C19.643 15.4804 19.5405 15.7348 19.5405 16C19.5405 16.2652 19.643 16.5196 19.8255 16.7071C20.008 16.8946 20.2555 17 20.5135 17H23.1081C23.3661 17 23.6136 16.8946 23.7961 16.7071C23.9786 16.5196 24.0811 16.2652 24.0811 16C24.0811 15.7348 23.9786 15.4804 23.7961 15.2929C23.6136 15.1054 23.3661 15 23.1081 15H20.5135C20.2555 15 20.008 15.1054 19.8255 15.2929Z"
      fill={fill}
    />
  </svg>
);

export default CardPaymentIcon;
